/**
 * External dependencies
 */
import { ButtonIcon } from '~cartzillagb/icons'
import { i18n } from 'cartzillagb'

/**
 * Internal dependencies
 */
import save from './save'
import edit from './edit'

/**
 * WordPress dependencies
 */
import { __ } from '@wordpress/i18n'


export const schema = {
	className : {
        type: 'string',
    },
    lgColumns : {
        type: 'number',
        default: 6,
    },
    mdColumns : {
        type: 'number',
        default: 12,
    },
    order : {
        type: 'number',
        default: 1,
    },
    smColumns : {
        type: 'number',
        default: 12,
    },
    columnId : {
        type: 'string',
    },
    backgroundImage: {
        type: 'string',
    },
    enableminheight: {
        type: 'boolean',
        default: false,
    },
    height : {
        type: 'number',
        default: 15,
    },

}

export const name = 'czgb/column'

export const settings = {
    title: __( 'Column', i18n ),
    icon: ButtonIcon,
    category: 'cartzillagb',
    example: {},
    keywords: [
        __( 'Column', i18n ),
        __( 'CartzillaGb', i18n ),
    ],
    attributes: schema,
    description: __( 'This block is an immediate child of Columns.', i18n ),
    supports: {
		inserter: false
	},

    edit,
    save,

    // CartzillaGB modules.
    modules: {
        'advanced-responsive': true,
    },
}